import React, {useEffect} from 'react'
import './experience.css'
import {BsPatchCheckFill} from 'react-icons/bs'
import AOS from 'aos'
import 'aos/dist/aos.css'
const Experience = () => {
  useEffect(() => {
    AOS.init()
  })
  return (

    <section id='experience'>
      <h5 data-aos="fade-up">What skills I have</h5>
      <h2 data-aos="fade-up">My Experience</h2>

      <div className="container container__experience" data-aos="fade-up">

        <div className="container experience__frontend">
          <h3>Frontend Development</h3>
          <div className="container experience__content">
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons' />
              <div>
              <h4> HTML</h4>
              <small>Experienced</small>

              </div>
             

            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons' />
             <div>
             <h4>CSS</h4>
              <small>Experienced</small>

              </div>
              

            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons' />
              <div>
              <h4> JavaScript</h4>
              <small>Experienced</small>

              </div>
             

            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons' />
              <div>
              <h4> ReactNative</h4>
              <small>Intermediate</small>

              </div>
              

            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons' />
              <div>
              <h4> WordPress</h4>
              <small>Expert</small>

              </div>
             

            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons' />
              <div>
              <h4> React</h4>
              <small>Experienced</small>

              </div>
              

            </article>

          </div>

        </div>
        {/* -- backend section -- */}
        <div className="container experience__backend">
        <h3>Backend Development</h3>
          <div className="container experience__content">
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons' />
              <div>
              <h4> PHP</h4>
              <small>Intermediate</small>
              </div>
              
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons' />
              <div>
              <h4>MySQL</h4>
              <small>Experienced</small>
              </div>
              
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons' />
              <div>
              <h4> API</h4>
              <small>Experienced</small>
              </div>
            </article>
             <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons' />
              <div>
              <h4> Node. js</h4>
              <small>Experienced</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons' />
              <div>
              <h4>  Express.js</h4>
              <small>Intermediate</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons' />
              <div>
              <h4> MongoDB</h4>
              <small>Experienced</small>
              </div>
            </article> 
          </div>
        </div>
      </div>
    </section>
  )
}

export default Experience